export const ballColorMap = {
  FB: "rgba(255, 0, 0, 0.7)",
  CB: "rgba(0, 128, 255, 0.7)",
  CH: "rgba(0, 117, 0, 0.7)",
  FT: "rgba(182, 33, 112, 0.7)",
  SL: "rgba(255, 255, 55, 0.7)",
  SP: "rgba(255, 128, 0, 0.7)",
  CT: "rgba(97, 48, 48, 0.7)",
  SC: "rgba(0, 242, 255, 0.7)",
  SFF: "rgba(217, 70, 0, 0.7)",
  KN: "rgba(111, 0, 210, 0.7)",
  OT: "rgba(173, 173, 173, 0.7)",
  '?': "rgba(39, 39, 39, 0.7)",
}

export const pitchColorMap = {
  FB: "rgba(255, 0, 0)",
  CB: "rgba(0, 128, 255)",
  CH: "rgba(0, 117, 0)",
  FT: "rgba(182, 33, 112)",
  SL: "rgba(255, 255, 55)",
  SP: "rgba(255, 128, 0)",
  CT: "rgba(97, 48, 48)",
  SC: "rgba(0, 242, 255)",
  SFF: "rgba(217, 70, 0)",
  KN: "rgba(111, 0, 210)",
  OT: "rgba(173, 173, 173)",
  '?': "rgba(39, 39, 39)",
}

export const ballTypeColorMap = {
  Fastballs: "rgba(255, 0, 0, 0.7)",
  Offspeed: "rgba(0, 100, 0, 0.7)",
  Breaking: "rgba(100, 100, 255, 0.7)"
}

export const hitLocationColorMap = {
  "H-FLYB": {
    pointBackgroundColor: "rgba(255, 0, 0, 0.6)",
    pointStyle: "triangle"
  },
  "H-POPB": {
    pointBackgroundColor: "rgba(255, 0, 0, 0.6)",
    pointStyle: "triangle"
  },
  "H-LINE": {
    pointBackgroundColor: "rgba(255, 0, 0, 0.6)",
    pointStyle: "rect"
  },
  "H-GROUND": {
    pointBackgroundColor: "rgba(255, 0, 0, 0.6)",
    pointStyle: "circle"
  },
  "OUT-FLYB": {
    pointBackgroundColor: "rgba(0, 0, 255, 0.6)",
    pointStyle: "triangle"
  },
  "OUT-POPB": {
    pointBackgroundColor: "rgba(0, 0, 255, 0.6)",
    pointStyle: "triangle"
  },
  "OUT-LINE": {
    pointBackgroundColor: "rgba(0, 0, 255, 0.6)",
    pointStyle: "rect"
  },
  "OUT-GROUND": {
    pointBackgroundColor: "rgba(0, 0, 255, 0.6)",
    pointStyle: "circle"
  },
}